<template>
  <div>
    <a-row class="row">
      <a-col :span="22">
        <div class="row-css">
          <div class="row-samp"></div>
          泵房总数 ({{ eringList.sum }}个)
        </div>
      </a-col>
      <a-col :span="2">
        <div class="row-css"></div>
      </a-col>
    </a-row>
    <div style="margin-left: 5px">
      <a-row>
        <a-col
          :span="12"
          class="col-gutter"
        >
          <div class="nav">
            <img
              src="/iconImg/bf-l.png"
              alt=""
            />
            <div class="title">正在运行</div>
            <div class="amount">{{ eringList.operationNum }}</div>
            <samp>个</samp>
          </div>
        </a-col>
        <a-col
          :span="12"
          class="col-gutter"
        >
          <div class="nav">
            <img
              src="/iconImg/bf-c.png"
              alt=""
            />
            <div class="title">预警泵房</div>
            <div class="amount">{{ eringList.warningNum }}</div>
            <samp>个</samp>
          </div>
        </a-col>
        <a-col
          :span="12"
          class="col-gutter"
        >
          <div class="nav">
            <img
              src="/iconImg/bf-hui.png"
              alt=""
            />
            <div class="title">离线泵房</div>
            <div class="amount">{{ eringList.offNum }}</div>
            <samp>个</samp>
          </div>
        </a-col>
        <a-col
          :span="12"
          class="col-gutter"
        >
          <div class="nav">
            <img
              src="/iconImg/bf-h.png"
              alt=""
            />
            <div class="title">报警泵房</div>
            <div class="amount">{{ eringList.alarmNum }}</div>
            <samp>个</samp>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import AvatarDropdown from '@/components/GlobalHeader/AvatarDropdown.vue'
export default {
  components: { AvatarDropdown },
  data () {
    return {
      eringList: {}
    }
  },
  created () {
    this.Homebottomeft()
  },
  methods: {
    Homebottomeft () {
      console.log('statistics/pump二次供水===')
      this.$http.get('/pipe-network/twice_water/statistics/pump').then((res) => {
        this.eringList = res.data
      })
    }
  }
}
</script>

<style lang='less' scoped>
.row {
  margin: 16px 0;
  height: 53px;
  border-bottom: 1px #f1f2f4 solid;
}
.row-css {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.row-samp {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  margin-left: 10px;
  background: #0265ff;
  border-radius: 3px;
}
.col-gutter {
  width: 45%;
  height: 68px;
  margin-left: 20px;
  margin-top: 20px;
  background-image: linear-gradient(90deg, #fafcff 0%, #f2f6ff 100%);
  border-radius: 4px;
}
.nav {
  display: flex;
  align-items: center;
}
img {
  width: 36px;
  height: 36px;
  margin: 15px 15px;
}
.title {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.56px;
  font-weight: 400;
}
.amount {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.63px;
  text-align: right;
  font-weight: 600;
  margin-left: 35%;
}
</style>
